module.exports = __webpack_public_path__ + "static/media/calibration_step3_save.7eeca100.gif";